<script>
	import Header from "./Design/Header.svelte";
	import Landing from "./Design/Landing.svelte";
	import TinyHouse from "./Design/TinyHouse.svelte";
	import Chucao from "./Design/Chucao.svelte";
	import Chercan from "./Design/Chercan.svelte";
	import AboutUs from "./Design/AboutUs.svelte";
	import Map from "./Design/Map.svelte";
</script>

<Header />
<main>
	<Landing />
	<TinyHouse/>
	<Chucao/>
	<Chercan/>
	<AboutUs/>
	<Map/>
</main>

<style lang="scss">
</style>
